<boi-session-end [titleLabel]="referenceDataLabels.UserSessionClosedTitle"
    [descriptionLabel]="referenceDataLabels.UserSessionClosedDescription">
</boi-session-end>